import { Component, OnInit, Inject } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { SystemComponentViewModel } from '../../../inventory/inventory-models';
import { InventoryService } from '../../../inventory/inventory-service.service';
import { ThermographyInspectionService } from '../../thermography-inspection.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-thermography-inspection-details-comment',
  templateUrl: './add-thermography-inspection-details-comment.html',
  styleUrls: ['./add-thermography-inspection-details-comment.scss']
})
export class AddThermographyInspectionDetailsCommentComponent implements OnInit {

  inspectionDetailID:number;
  comment: string;
  savingComment = false;
  isInspector = false;
  isInterpreter = false;
  newComment= '';
  isedit:boolean;
  isWsre: boolean = false;
  equnitId: number;
  component: SystemComponentViewModel;
  screenId: number;
  constructor(
    public _dialogRef: MatDialogRef<AddThermographyInspectionDetailsCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private _notify: NotificationsService,
    private _thermographyService: ThermographyInspectionService,
    private inventoryService: InventoryService,
  ) { }

  ngOnInit() {
    this.inspectionDetailID = this.data.inspectionDetailID;
    this.newComment = this.data.Inspcomment;
    this.isedit=this.data.isedit;
    this.isWsre = this.data.isWsre;
    this.equnitId = this.data.equipmentId;
    this.component = this.data.component;
    this.screenId = this.data.screenId;
  }

  success(title: string, message: string) {
    this._notify.success(title, message);
    this._dialogRef.close(true);
    this.savingComment = false;
  }

  error(title: string, message: string, err: any) {
    this._notify.error(title, message);
    console.error(err);
    this.savingComment = false;
  }
  updateComment() {
    if (this.isWsre == false) {
      this._thermographyService.updateInspectionDetailComment(this.inspectionDetailID, this.newComment).subscribe(r => {
        if (r.m_Item1) {
          this.success('Saved', r.m_Item2);
        } else {
          this.error('Failed', r.m_Item2, r.m_Item2);
        }
      }, err => {
        this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
      });
    }
    else if (this.equnitId > 0) {
      this.updateInventoryComponentComment();
    }
    else {
      this.updateCommentWSREFrameComponent();
    }

  }

  updateCommentWSREFrameComponent(){
    this._thermographyService.updateInspectionDetailCommentWSRE(this.inspectionDetailID, this.newComment, this.screenId ).subscribe(r => {
      if (r.m_Item1) {
        this.success('Saved', r.m_Item2);
      } else {
        this.error('Failed', r.m_Item2, r.m_Item2);
      }
    }, err => {
      this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
    });
  }

  updateInventoryComponentComment() {
    this.component.Comment = this.newComment;
    this.component.ScreenId = this.screenId;
    //this.inventoryService.updateSystemInInventoryComment(this.component).subscribe(result => {
    this.inventoryService.updateSystemInInventoryInfo(this.component).subscribe(result => {
      if (result.m_Item1) {
        this.success('Saved', result.m_Item2);
      } else {
        this.error('Failed', result.m_Item2, "");
      }
    }, err => {
      this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
    });
  }

  onNoClick(): void {
    this._dialogRef.close(false);
  }

}
